import SharedHelper from '@/Helpers/Shared';
export default {
  inject: ['load', 'loadReport'],
  mixins: [SharedHelper],
  data() {
    return {
      allAverageTimes: [],
      stationsAverageTimes: [],
      stationsAverageTimesExel: [],
      loading: {
        gettingStationsAverageTimes: false,
      },
      stationTimeHeaders: [
        {
          title: 'فراخوان',
          value: 'receiveTillDispatch',
          text: 'مدت زمان صرف شده از لحظه ارسال فایل به واحد اعزام و راهبری آمبولانس تا لحظه ارسال پیام به پایگاه (ابلاغ فوریت به پایگاه)',
        },
        {
          title: 'کنش',
          value: 'answerTillDispatch',
          text: 'مدت زمان صرف شده از لحظه پاسخگویی پرستار تریاژ تا لحظه ابلاغ فوریت به پایگاه',
        },
        {
          title: 'واکنش',
          value: 'dispatchTillMoveFromStation',
          text: 'مدت زمان صرف شده از لحظه ابلاغ فوریت به پایگاه تا لحظه حرکت کد به سمت محل فوریت',
        },
        {
          title: 'پاسخگویی',
          value: 'answerTillArriveToLocation',
          text: 'مدت زمان صرف شده از لحظه برقراری تماس مددجو  تا لحظه رسیدن تکنسین به محل فوریت',
        },
        {
          title: 'صحنه',
          value: 'arriveToLocationTillMoveFromLocation',
          text: 'مدت زمان صرف شده از لحظه رسیدن به محل فوریت تا لحظه حرکت به سمت بیمارستان',
        },
        {
          title: 'انتقال',
          value: 'moveFromLocationTillArriveToHospital',
          text: 'مدت زمان صرف شده از لحظه حرکت کد به سمت بیمارستان تا لحظه رسیدن به تریاژ بیمارستان',
        },
        {
          title: 'ماندگاری در بیمارستان',
          value: 'arriveToHospitalTillMoveFromHospital',
          text: 'مدت زمان صرف شده از لحظه رسیدن به بیمارستان تا لحظه حرکت کد از بیمارستان به سمت پایگاه',
        },
      ],
    };
  },
  methods: {
    getAverageTimesReport: function (params) {
      this.load.val = true;
      this.$store
        .dispatch('getAverageTimesReportDispatch', params)
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            const data = this.$store.state.reportModule.averageTimesReport;
            this.allAverageTimes = this.transformAllAverageTimes(data);
          } else {
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getAverageTimesReport(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    getAverageStationTimesReport: function (params) {
      this.load.val = true;
      this.loading.gettingStationsAverageTimes = true;
      this.$store
        .dispatch('getStationAverageTimesReportDispatch', params)
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            const data = this.$store.state.reportModule.stationAverageTimesReport;
            this.stationsAverageTimesExel = data;
            this.stationsAverageTimes = this.transformStationAverageTimes(data);
          } else {
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getAverageTimesReport(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
          this.loading.gettingStationsAverageTimes = false;
        });
    },
    getPcrFormAccidentTraumaFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPcrFormAccidentTrauma', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormAccidentTrauma);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getPcrFormAccidentTraumaFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getPcrFormAccidentTraumaHospitalFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPcrFormAccidentTraumaHospital', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(
              this.$store.state.reportModule.pcrFormAccidentTraumaHospital,
            );
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getPcrFormAccidentTraumaHospitalFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getPcrFormOtherTraumaFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPcrFormOtherTrauma', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormOtherTrauma);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getPcrFormOtherTraumaFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getPcrFormOtherTraumaHospitalFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPcrFormOtherTraumaHospital', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormOtherTraumaHospital);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getPcrFormOtherTraumaHospitalFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getPcrFormDiseaseFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPcrFormDisease', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormDisease);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getPcrFormDiseaseFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getPcrFormDiseaseHospitalFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPcrFormDiseaseHospital', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormDiseaseHospital);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getPcrFormDiseaseHospitalFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getPcrFormHeartFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPcrFormHeart', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormHeart);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getPcrFormHeartFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getPcrFormHeartHospitalFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPcrFormHeartHospital', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormHeartHospital);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getPcrFormHeartHospitalFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getPcrFormBrainStrokeFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPcrFormBrainStroke', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormBrainStroke);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getPcrFormBrainStrokeFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getPcrFormBrainStrokeHospitalFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPcrFormBrainStrokeHospital', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormBrainStrokeHospital);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getPcrFormBrainStrokeHospitalFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getPcrFormWithoutPatientFunction: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPcrFormWithoutPatient', missionPhoneId).then(() => {
        if (this.$store.state.reportModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormWithoutPatient);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.reportModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.reportModule.successFlag) {
                this.getPcrFormWithoutPatientFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getPcrFormWithoutPatientHospitalFunction: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPcrFormWithoutPatientHospital', missionPhoneId).then(() => {
        if (this.$store.state.reportModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormWithoutPatientHospital);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.reportModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.reportModule.successFlag) {
                this.getPcrFormWithoutPatientHospitalFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getQCSurveyReportFunction: function (
      fromDate,
      toDate,
      missionId,
      surveyCategoryId,
      pageNumber = 1,
      pageSize = 10,
    ) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getQCSurveyReport', {
          fromDate: fromDate,
          toDate: toDate,
          missionId: missionId,
          surveyCategoryId: surveyCategoryId,
          pageNumber: pageNumber,
          pageSize: pageSize,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.reportModule.qCSurvey);
            this.totalPages = Number(this.$store.state.reportModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.reportModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.reportModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getQCSurveyReportFunction(
                    fromDate,
                    toDate,
                    missionId,
                    surveyCategoryId,
                    pageNumber,
                    pageSize,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getQCOnlineUsersReportFunction: function (
      fromDate,
      toDate,
      roleId,
      pageNumber = 1,
      pageSize = 10,
    ) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getQCOnlineUsersReport', {
          fromDate: fromDate,
          toDate: toDate,
          roleId: roleId,
          pageNumber: pageNumber,
          pageSize: pageSize,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.reportModule.qCOnlineUsers);
            this.totalPages = Number(this.$store.state.reportModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.reportModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.reportModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getQCOnlineUsersReportFunction(
                    fromDate,
                    toDate,
                    roleId,
                    pageNumber,
                    pageSize,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getQCUsersLoginLogoutReportFunction: function (
      fromDate,
      toDate,
      userId,
      pageNumber = 1,
      pageSize = 10,
    ) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getQCUsersLoginLogoutReport', {
          fromDate: fromDate,
          toDate: toDate,
          userId: userId,
          pageNumber: pageNumber,
          pageSize: pageSize,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (
              this.$route.name == 'qcUsersLoginLogoutReport' ||
              this.$route.name == 'user115AllLoginLogout'
            ) {
              this.makeDataReady(this.$store.state.reportModule.qCUsersLoginLogout);
              this.totalPages = Number(this.$store.state.reportModule.totalPages);
              if (this.$refs.pagination) {
                this.$refs.pagination.totalPages = Number(this.$store.state.reportModule.totalPages);
                this.$refs.pagination.totalRecords = Number(this.$store.state.reportModule.totalRecords);
              }
              if (this.load.val) {
                this.load.val = false;
              }
            } else if (
              this.$route.name == 'qcUser115Dashboard' ||
              this.$route.name == 'qcUser800Dashboard' ||
              this.$route.name == 'qcUserTechnicianDashboard' ||
              this.$route.name == 'qcUserDoctorDashboard' ||
              this.$route.name == 'qcUserAdmissionDashboard'
            ) {
              this.readyLoginLogoutData(this.$store.state.reportModule.qCUsersLoginLogout);
            }
          } else {
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getQCUsersLoginLogoutReportFunction(
                    fromDate,
                    toDate,
                    userId,
                    pageNumber,
                    pageSize,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.load.val = false));
    },
    getQCCallsReportFunction: function (
      fromDate,
      toDate,
      callTagId,
      source,
      destination,
      userId,
      pageNumber,
      pageSize,
    ) {
      if (this.$route.name == 'qcCallsReport') {
        if (!this.load.val) {
          this.load.val = true;
        }
      }
      this.$store
        .dispatch('getQCCallsReport', {
          fromDate: fromDate,
          toDate: toDate,
          userId: userId,
          callTagId: callTagId,
          source,
          destination: destination,
          pageNumber,
          pageSize,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.$route.name == 'qcCallsReport' || this.$route.name == 'user115AllCalls') {
              this.makeDataReady(this.$store.state.reportModule.qCCalls);
              // this.totalPages = Number(
              //   this.$store.state.reportModule.totalPages
              // );
              try {
                this.setPagination(this.$store.state.reportModule);
              } catch (error) {
                console.log("A error : ", error);
              }
              // this.setTotalPagesFun(Number(this.totalPages));
              if (this.$route.name == 'user115AllCalls') {
                this.totalPages = Number(this.$store.state.reportModule.totalPages);
                if (this.$refs.pagination) {
                  this.$refs.pagination.totalPages = Number(this.$store.state.reportModule.totalPages);
                  this.$refs.pagination.totalRecords = Number(this.$store.state.reportModule.totalRecords);
                }
              }
            } else if (this.$route.name == 'qcUser115Dashboard') {
              this.readyCallData(this.$store.state.reportModule.qCCalls);
            }
          } else {
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getQCCallsReportFunction(fromDate, toDate, null, null, null, userId, pageNumber, pageSize);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    getQCMissionTimesReportFunction: function (
      fromDate,
      toDate,
      firstUserId,
      secondUserId,
      phoneCode,
      vehicleTypeId,
      cityId,
      searchDispatchTillMoveMinimumSecond,
      searchDispatchTillMoveMinimumMinute,
      searchMoveTillArriveMinimumSecond,
      searchMoveTillArriveMinimumMinute,
      searchPatientWaitingDurationMinimumSecond,
      searchPatientWaitingDurationMinimumMinute,
      searchHospitalWaitingDurationMinimumSecond,
      searchHospitalWaitingDurationMinimumMinute,
      searchMissionDurationMinimumSecond,
      searchMissionDurationMinimumMinute,
      searchMissionDurationMinimumHoure,
      pageNumber = 1,
      pageSize = 10,
      missionId,
    ) {
      if (!this.load.val) {
        this.load.val = true;
      }

      let dispatchTillMoveMinimum = null;
      let dispatchTillMoveMinimumTotal = null;
      if (searchDispatchTillMoveMinimumSecond || searchDispatchTillMoveMinimumMinute) {
        if (searchDispatchTillMoveMinimumMinute) {
          dispatchTillMoveMinimumTotal = Number(searchDispatchTillMoveMinimumMinute) * 60;
        }
        dispatchTillMoveMinimum =
          Number(dispatchTillMoveMinimumTotal) + Number(searchDispatchTillMoveMinimumSecond);
      }
      let moveTillArriveMinimum = null;
      let moveTillArriveMinimumTotal = null;
      if (searchMoveTillArriveMinimumSecond || searchMoveTillArriveMinimumMinute) {
        if (searchMoveTillArriveMinimumMinute) {
          moveTillArriveMinimumTotal = Number(searchMoveTillArriveMinimumMinute) * 60;
        }
        moveTillArriveMinimum =
          Number(moveTillArriveMinimumTotal) + Number(searchMoveTillArriveMinimumSecond);
      }
      let patientWaitingDurationMinimum = null;
      let patientWaitingDurationMinimumTotal = null;
      if (searchPatientWaitingDurationMinimumSecond || searchPatientWaitingDurationMinimumMinute) {
        if (searchPatientWaitingDurationMinimumMinute) {
          patientWaitingDurationMinimumTotal =
            Number(searchPatientWaitingDurationMinimumMinute) * 60;
        }
        patientWaitingDurationMinimum =
          Number(patientWaitingDurationMinimumTotal) +
          Number(searchPatientWaitingDurationMinimumSecond);
      }
      let hospitalWaitingDurationMinimum = null;
      let hospitalWaitingDurationMinimumTotal = null;
      if (
        searchHospitalWaitingDurationMinimumSecond ||
        searchHospitalWaitingDurationMinimumMinute
      ) {
        if (searchHospitalWaitingDurationMinimumMinute) {
          hospitalWaitingDurationMinimumTotal =
            Number(searchHospitalWaitingDurationMinimumMinute) * 60;
        }
        hospitalWaitingDurationMinimum =
          Number(hospitalWaitingDurationMinimumTotal) +
          Number(searchHospitalWaitingDurationMinimumSecond);
      }
      let missionDurationMinimum = null;
      let missionDurationMinimumTotal = null;
      let missionDurationMinimumHoureTotal = null;
      if (
        searchMissionDurationMinimumSecond ||
        searchMissionDurationMinimumMinute ||
        searchMissionDurationMinimumHoure
      ) {
        if (searchMissionDurationMinimumHoure) {
          missionDurationMinimumHoureTotal = Number(searchMissionDurationMinimumHoure) * 3600;
        }
        if (searchMissionDurationMinimumMinute) {
          missionDurationMinimumTotal = Number(searchMissionDurationMinimumMinute) * 60;
        }
        missionDurationMinimum =
          Number(missionDurationMinimumTotal) +
          Number(searchMissionDurationMinimumSecond) +
          Number(missionDurationMinimumHoureTotal);
      }
      this.$store
        .dispatch('getQCMissionTimesReport', {
          fromDate: fromDate,
          toDate: toDate,
          firstUserId: firstUserId,
          secondUserId: secondUserId,
          phoneCode: phoneCode,
          vehicleTypeId: vehicleTypeId,
          cityId: cityId,
          dispatchTillMoveMinimum: dispatchTillMoveMinimum,
          moveTillArriveMinimum: moveTillArriveMinimum,
          hospitalWaitingDurationMinimum: hospitalWaitingDurationMinimum,
          patientWaitingDurationMinimum: patientWaitingDurationMinimum,
          missionDurationMinimum: missionDurationMinimum,
          pageNumber: pageNumber,
          pageSize: pageSize,
          missionId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.reportModule.qCMissionTimes);
            this.totalPages = Number(this.$store.state.reportModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.reportModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.reportModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getQCMissionTimesReportFunction(
                    fromDate,
                    toDate,
                    firstUserId,
                    secondUserId,
                    phoneCode,
                    vehicleTypeId,
                    cityId,
                    searchDispatchTillMoveMinimumSecond,
                    searchDispatchTillMoveMinimumMinute,
                    searchMoveTillArriveMinimumSecond,
                    searchMoveTillArriveMinimumMinute,
                    searchPatientWaitingDurationMinimumSecond,
                    searchPatientWaitingDurationMinimumMinute,
                    searchHospitalWaitingDurationMinimumSecond,
                    searchHospitalWaitingDurationMinimumMinute,
                    searchMissionDurationMinimumSecond,
                    searchMissionDurationMinimumMinute,
                    searchMissionDurationMinimumHoure,
                    pageNumber,
                    pageSize,
                    missionId,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getQCMissionFenceTimesReportFunction: function (
      fromDate,
      toDate,
      firstUserId,
      secondUserId,
      phoneCode,
      vehicleTypeId,
      cityId,
      searchDispatchTillMoveMinimumSecond,
      searchDispatchTillMoveMinimumMinute,
      searchMoveTillArriveMinimumSecond,
      searchMoveTillArriveMinimumMinute,
      searchPatientWaitingDurationMinimumSecond,
      searchPatientWaitingDurationMinimumMinute,
      searchHospitalWaitingDurationMinimumSecond,
      searchHospitalWaitingDurationMinimumMinute,
      searchMissionDurationMinimumSecond,
      searchMissionDurationMinimumMinute,
      searchMissionDurationMinimumHoure,
      pageNumber = 1,
      pageSize = 10,
      MissionIdentifier,
    ) {
      if (!this.load.val) {
        this.load.val = true;
      }
      let dispatchTillMoveMinimum = null;
      let dispatchTillMoveMinimumTotal = null;
      if (searchDispatchTillMoveMinimumSecond || searchDispatchTillMoveMinimumMinute) {
        if (searchDispatchTillMoveMinimumMinute) {
          dispatchTillMoveMinimumTotal = Number(searchDispatchTillMoveMinimumMinute) * 60;
        }
        dispatchTillMoveMinimum =
          Number(dispatchTillMoveMinimumTotal) + Number(searchDispatchTillMoveMinimumSecond);
      }
      let moveTillArriveMinimum = null;
      let moveTillArriveMinimumTotal = null;
      if (searchMoveTillArriveMinimumSecond || searchMoveTillArriveMinimumMinute) {
        if (searchMoveTillArriveMinimumMinute) {
          moveTillArriveMinimumTotal = Number(searchMoveTillArriveMinimumMinute) * 60;
        }
        moveTillArriveMinimum =
          Number(moveTillArriveMinimumTotal) + Number(searchMoveTillArriveMinimumSecond);
      }
      let patientWaitingDurationMinimum = null;
      let patientWaitingDurationMinimumTotal = null;
      if (searchPatientWaitingDurationMinimumSecond || searchPatientWaitingDurationMinimumMinute) {
        if (searchPatientWaitingDurationMinimumMinute) {
          patientWaitingDurationMinimumTotal =
            Number(searchPatientWaitingDurationMinimumMinute) * 60;
        }
        patientWaitingDurationMinimum =
          Number(patientWaitingDurationMinimumTotal) +
          Number(searchPatientWaitingDurationMinimumSecond);
      }
      let hospitalWaitingDurationMinimum = null;
      let hospitalWaitingDurationMinimumTotal = null;
      if (
        searchHospitalWaitingDurationMinimumSecond ||
        searchHospitalWaitingDurationMinimumMinute
      ) {
        if (searchHospitalWaitingDurationMinimumMinute) {
          hospitalWaitingDurationMinimumTotal =
            Number(searchHospitalWaitingDurationMinimumMinute) * 60;
        }
        hospitalWaitingDurationMinimum =
          Number(hospitalWaitingDurationMinimumTotal) +
          Number(searchHospitalWaitingDurationMinimumSecond);
      }
      let missionDurationMinimum = null;
      let missionDurationMinimumTotal = null;
      let missionDurationMinimumHoureTotal = null;
      if (
        searchMissionDurationMinimumSecond ||
        searchMissionDurationMinimumMinute ||
        searchMissionDurationMinimumHoure
      ) {
        if (searchMissionDurationMinimumHoure) {
          missionDurationMinimumHoureTotal = Number(searchMissionDurationMinimumHoure) * 3600;
        }
        if (searchMissionDurationMinimumMinute) {
          missionDurationMinimumTotal = Number(searchMissionDurationMinimumMinute) * 60;
        }
        missionDurationMinimum =
          Number(missionDurationMinimumTotal) +
          Number(searchMissionDurationMinimumSecond) +
          Number(missionDurationMinimumHoureTotal);
      }
      this.$store
        .dispatch('getQCMissionFenceTimesReport', {
          fromDate: fromDate,
          toDate: toDate,
          firstUserId: firstUserId,
          secondUserId: secondUserId,
          phoneCode: phoneCode,
          vehicleTypeId: vehicleTypeId,
          cityId: cityId,
          dispatchTillMoveMinimum: dispatchTillMoveMinimum,
          moveTillArriveMinimum: moveTillArriveMinimum,
          hospitalWaitingDurationMinimum: hospitalWaitingDurationMinimum,
          patientWaitingDurationMinimum: patientWaitingDurationMinimum,
          missionDurationMinimum: missionDurationMinimum,
          pageNumber: pageNumber,
          pageSize: pageSize,
          MissionIdentifier,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.reportModule.qCMissionFenceTimes);
            this.totalPages = Number(this.$store.state.reportModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.reportModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.reportModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getQCMissionFenceTimesReportFunction(
                    fromDate,
                    toDate,
                    firstUserId,
                    secondUserId,
                    phoneCode,
                    vehicleTypeId,
                    cityId,
                    searchDispatchTillMoveMinimumSecond,
                    searchDispatchTillMoveMinimumMinute,
                    searchMoveTillArriveMinimumSecond,
                    searchMoveTillArriveMinimumMinute,
                    searchPatientWaitingDurationMinimumSecond,
                    searchPatientWaitingDurationMinimumMinute,
                    searchHospitalWaitingDurationMinimumSecond,
                    searchHospitalWaitingDurationMinimumMinute,
                    searchMissionDurationMinimumSecond,
                    searchMissionDurationMinimumMinute,
                    searchMissionDurationMinimumHoure,
                    pageNumber,
                    pageSize,
                    MissionIdentifier,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getQCTechnicianPerformancePaginationReportFunction: function (
      fromDate,
      toDate,
      cityId,
      userId,
      pageNumber = 1,
      pageSize = 10,
    ) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getQCTechnicianPerformancePaginationReport', {
          fromDate: fromDate,
          toDate: toDate,
          userId: userId,
          cityId: cityId,
          pageNumber: pageNumber,
          pageSize: pageSize,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.reportModule.qCTechnicianPerformancePagination);
            this.totalPages = Number(this.$store.state.reportModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.reportModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.reportModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getQCTechnicianPerformancePaginationReportFunction(
                    fromDate,
                    toDate,
                    cityId,
                    userId,
                    pageNumber,
                    pageSize,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getQCUsersForQCReportFunction: function (
      fullName,
      roleId,
      nationalCode,
      pageNumber = 1,
      pageSize = 10,
    ) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getQCUsersForQCReport', {
          fullName: fullName,
          roleId: roleId,
          nationalCode: nationalCode,
          pageNumber: pageNumber,
          pageSize: pageSize,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.reportModule.qCUsersForQC);
            this.totalPages = Number(this.$store.state.reportModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.reportModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.reportModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getQCUsersForQCReportFunction(
                    fullName,
                    roleId,
                    nationalCode,
                    pageNumber,
                    pageSize,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getMissionPhoneWithResultByZoneForDailyReportAmarFunction: function (fromDate, toDate, cityId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getMissionPhoneWithResultByZoneForDailyReport', {
          fromDate,
          toDate,
          cityId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeMissionByZoneDataReady(
              this.$store.state.reportModule.missionPhoneWithResultByZone,
            );
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getMissionPhoneWithResultByZoneForDailyReportAmarFunction(
                    fromDate,
                    toDate,
                    cityId,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getPatientCountByDiagnosisForDailyReportAmarFunction: function (fromDate, toDate, cityId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPatientCountByDiagnosisForDailyReport', {
          fromDate,
          toDate,
          cityId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDiagnosisDataReady(this.$store.state.reportModule.patientCountByDiagnosis);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getPatientCountByDiagnosisForDailyReportAmarFunction(
                    fromDate,
                    toDate,
                    cityId,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getInboundCallsForDailyReportAmarFunction: function (fromDate, toDate, cityId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getInboundCallsForDailyReport', { fromDate, toDate, cityId })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeCallsDataReady(this.$store.state.reportModule.inboundCalls);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getInboundCallsForDailyReportAmarFunction(fromDate, toDate, cityId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getDailyByZoneReportAmarFunction: function (fromDate, toDate, cityId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDailyByZoneReport', { fromDate, toDate, cityId }).then(() => {
        if (this.$store.state.reportModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.makeDataReady(this.$store.state.reportModule.dailyByZone);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.reportModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.reportModule.successFlag) {
                this.getDailyByZoneReportAmarFunction(fromDate, toDate, cityId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getDailyByGeographicalTypeReportAmarFunction: function (fromDate, toDate, cityId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getDailyByGeographicalTypeReport', {
          fromDate,
          toDate,
          cityId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.reportModule.dailyByGeographicalType);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getDailyByGeographicalTypeReportAmarFunction(fromDate, toDate, cityId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getDailyByGeographicalTypeWithCodeReportAmarFunction: function (fromDate, toDate, cityId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getDailyByGeographicalTypeWithCodeReport', {
          fromDate,
          toDate,
          cityId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.reportModule.dailyByGeographicalTypeWithCode);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getDailyByGeographicalTypeWithCodeReportAmarFunction(
                    fromDate,
                    toDate,
                    cityId,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getAmarCodeReportFunction: function (
      fromDate,
      toDate,
      phoneId,
      cityId,
      vehicleTypeId,
      pageNumber = 1,
      pageSize = 10,
    ) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAmarCodeReport', {
          fromDate: fromDate,
          toDate: toDate,
          phoneId: phoneId,
          cityId: cityId,
          vehicleTypeId: vehicleTypeId,
          pageNumber: pageNumber,
          pageSize: pageSize,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.reportModule.amarCodeActivity);
            this.totalPages = Number(this.$store.state.reportModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.reportModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.reportModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getAmarCodeReportFunction(
                    fromDate,
                    toDate,
                    phoneId,
                    cityId,
                    vehicleTypeId,
                    pageNumber,
                    pageSize,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getAmarRefuelReportFunction: function (
      fromDate,
      toDate,
      phoneId,
      vehicleId,
      userId,
      minimumLiter,
      cityId,
      pageNumber = 1,
      pageSize = 10,
    ) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAmarRefuelReport', {
          fromDate: fromDate,
          toDate: toDate,
          phoneId: phoneId,
          vehicleId: vehicleId,
          userId: userId,
          minimumLiter: minimumLiter,
          cityId: cityId,
          pageNumber: pageNumber,
          pageSize: pageSize,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.reportModule.amarRefuel);
            this.totalPages = Number(this.$store.state.reportModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.reportModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.reportModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getAmarRefuelReportFunction(
                    fromDate,
                    toDate,
                    phoneId,
                    vehicleId,
                    userId,
                    minimumLiter,
                    cityId,
                    pageNumber,
                    pageSize,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getAmarHeatMapReportFunction: function (fromDate, toDate, diagnosis, resultId, tagId, cityId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAmarHeatMapReport', {
          fromDate: fromDate,
          toDate: toDate,
          diagnosis: diagnosis,
          resultId: resultId,
          tagId: tagId,
          cityId: cityId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReady(this.$store.state.reportModule.amarHeatMap);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getAmarHeatMapReportFunction(
                    fromDate,
                    toDate,
                    diagnosis,
                    resultId,
                    tagId,
                    cityId,
                  );
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getReportParameterDataFunction: function (id, index) {
      this.$store.dispatch('getReportParameterData', id).then(() => {
        if (this.$store.state.reportModule.successFlag) {
          this.makeSelectParameterDataReady(this.$store.state.reportModule.amarBaseTypeData, index);
        } else {
          if (this.$store.state.reportModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.reportModule.successFlag) {
                this.getReportParameterDataFunction(id, index);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    setReportParamsForCustomReportAmarFunction: function (data) {
      if (!this.loadReport.val) {
        this.loadReport.val = true;
      }
      this.$store.dispatch('setReportParamsForCustomReportAmar', data).then(() => {
        if (this.$store.state.reportModule.successFlag) {
          let data = this.$store.state.reportModule.customReportInfo;
          this.makeTableReady(data);
        } else {
          if (this.$store.state.reportModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.reportModule.successFlag) {
                this.setReportParamsForCustomReportAmarFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      }).finally(() => {
        this.loadReport.val = false;
      });
    },
    //Limit Report
    getLimitPcrFormAccidentTraumaFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getHospitalPcrFormAccidentTrauma', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormAccidentTrauma);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getLimitPcrFormAccidentTraumaFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getLimitPcrFormOtherTraumaFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getHospitalPcrFormOtherTrauma', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormOtherTrauma);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getLimitPcrFormOtherTraumaFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getLimitPcrFormBrainStrokeFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getHospitalPcrFormBrainStroke', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormBrainStroke);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getLimitPcrFormBrainStrokeFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getLimitPcrFormHeartFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getHospitalPcrFormHeart', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormHeart);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getLimitPcrFormHeartFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getLimitPcrFormDiseaseFunction: function (missionPhoneId, patientId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getHospitalPcrFormDisease', {
          missionPhoneId: missionPhoneId,
          patientId: patientId,
        })
        .then(() => {
          if (this.$store.state.reportModule.successFlag) {
            if (this.load.val) {
              this.load.val = false;
            }
            this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormDisease);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.reportModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.reportModule.successFlag) {
                  this.getLimitPcrFormDiseaseFunction(missionPhoneId, patientId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getLimitPcrFormWithoutPatientFunction: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getHospitalPcrFormWithoutPatient', missionPhoneId).then(() => {
        if (this.$store.state.reportModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          this.makeDataReadyForExport(this.$store.state.reportModule.pcrFormWithoutPatient);
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.reportModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.reportModule.successFlag) {
                this.getLimitPcrFormWithoutPatientFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },

    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    showError: function () {
      const errorText = this.$store.state.reportModule.error;
      this.showErrorAlert(errorText);
    },
  },
};
